import React from "react";
import {
  ActivityIcon,
  Bingo,
  CardGameIcon,
  ClockIcon,
  Fish,
  FlameIcon,
  GamepadIcon,
  HomeIcon,
  InviteIcon,
  Im,
  Pb,
  Qpyx,
  RecommendIcon,
  Rmyxsvg,
  SlotIcon,
  SportsIcon,
  StarIcon,
  Tjyx,
  Vip,
  Ycyx,
  Yaoqing,
  Zrsx,
  Live,
} from "@/assets/svg-icon";
import { UserIcon } from "@/componentsUI/Icon";
import {
  GameCategoryInfo,
  GameCategoryType,
} from "@/features/common/gameCategory/gameCategory";

/**
 * 根据分类键获取对应的图标组件
 */
/**
 * Get icon component by category key
 * 根据分类键获取对应的图标组件
 */
export function getIconFromKey(key: string): React.ReactNode {
  switch (key) {
    case "home":
    case "casino":
      return React.createElement(HomeIcon); // All Games - 首页/所有游戏
    case "hot":
    case "hotList":
      return React.createElement(FlameIcon); // Hot Games - 热门游戏
    case "recommend":
    case "recommendList":
      return React.createElement(RecommendIcon); // Recommend - 推荐
    case "slot":
    case "slotList":
    case "slots":
      return React.createElement(SlotIcon); // Slots - 老虎机
    case "table":
    case "tableList":
    case "chess":
      return React.createElement(CardGameIcon); // Table Games - 棋牌游戏
    case "fishing":
      return React.createElement(Fish); // Fishing - 捕鱼
    case "live":
    case "videoConferencing":
      return React.createElement(Live); // Live Casino - 真人娱乐
    case "mini":
    case "miniGameList":
      return React.createElement(GamepadIcon); // Mini Games - 小游戏
    case "original":
    case "originalList":
      return React.createElement(GamepadIcon); // Original - 原创游戏
    case "favorite":
    case "favoriteList":
      return React.createElement(StarIcon); // Favorites - 收藏
    case "played":
    case "playedList":
      return React.createElement(ClockIcon); // Recently Played - 最近游戏
    case "sport":
      return React.createElement(SportsIcon); // Sports - 体育
    case "sportsIm":
      return React.createElement(Im); // IM Sports - IM体育
    case "sportsPb":
      return React.createElement(Pb); // PB Sports - PB体育
    case "activity":
      return React.createElement(ActivityIcon); // Activity - 活动
    case "vip":
      return React.createElement(Vip); // VIP - VIP
    case "affiliate":
      return React.createElement(InviteIcon); // Affiliate - 邀请/推广
    case "bingo":
      return React.createElement(Bingo); // Bingo - 宾果
    // Platform brands - 平台品牌游戏
    case "jili":
    case "jiliList":
      return React.createElement(Zrsx); // JILI
    case "pg":
    case "pgList":
      return React.createElement(Ycyx); // PG
    case "pp":
    case "ppList":
      return React.createElement(Qpyx); // PP
    case "jdb":
    case "jdbList":
      return React.createElement(Tjyx); // NEW GAMES
    case "hacksaw":
    case "hacksawList":
      return React.createElement(Rmyxsvg); // Christmas / Hacksaw
    case "interesting":
    case "interestingGameList":
      return React.createElement(Yaoqing); // Interesting
    default:
      return React.createElement(UserIcon); // Default - 默认用户图标
  }
}

/**
 * 默认游戏分类配置
 */
export const defaultGameCategories: GameCategoryInfo[] = [
  {
    key: "casino",
    nameKey: "All Games",
    name: "All Games",
    icon: getIconFromKey("casino"),
    path: "/home",
    type: GameCategoryType.HOME,
    sort: 0,
    enabled: true,
  },
  {
    key: "hot",
    nameKey: "Hot Games",
    name: "Hot Games",
    icon: getIconFromKey("hot"),
    path: "/hotList",
    dataKey: "hotList.gameList",
    type: GameCategoryType.HOT,
    sort: 1,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "recommend",
    nameKey: "Recommend",
    name: "Recommend",
    icon: getIconFromKey("recommend"),
    path: "/recommendList",
    dataKey: "recommendList.gameList",
    type: GameCategoryType.RECOMMEND,
    sort: 2,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "slots",
    nameKey: "Slots",
    name: "Slots",
    icon: getIconFromKey("slots"),
    path: "/slotList",
    dataKey: "slotsList.gameList",
    type: GameCategoryType.SLOT,
    sort: 4,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  // Platform brands - keep original brand name casing
  {
    key: "jili",
    nameKey: "JILI",
    name: "JILI",
    icon: getIconFromKey("jili"),
    path: "/jiliList",
    dataKey: "jiliGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 5,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "jdb",
    nameKey: "JDB",
    name: "JDB",
    icon: getIconFromKey("jdb"),
    path: "/jdbList",
    dataKey: "jdbGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 3,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "pp",
    nameKey: "PP",
    name: "PP",
    icon: getIconFromKey("pp"),
    path: "/ppList",
    dataKey: "ppGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 6,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "pg",
    nameKey: "PG",
    name: "PG",
    icon: getIconFromKey("pg"),
    path: "/pgList",
    dataKey: "pgGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 7,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "hacksaw",
    nameKey: "Hacksaw",
    name: "Hacksaw",
    icon: getIconFromKey("hacksaw"),
    path: "/hacksawList",
    dataKey: "hacksawGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 8,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "interesting",
    nameKey: "Interesting",
    name: "Interesting",
    icon: getIconFromKey("interesting"),
    path: "/interestingList",
    dataKey: "interestingGameList.gameList",
    type: GameCategoryType.PLATFORM,
    sort: 9,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "table",
    nameKey: "Table Games",
    name: "Table Games",
    icon: getIconFromKey("table"),
    path: "/tableList",
    dataKey: "chessList.gameList",
    type: GameCategoryType.TABLE,
    sort: 14,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "fishing",
    nameKey: "Fishing",
    name: "Fishing",
    icon: getIconFromKey("fishing"),
    path: "/fishing",
    dataKey: "happyFishingList.gameList",
    type: GameCategoryType.FISHING,
    sort: 12,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "mini",
    nameKey: "Mini Games",
    name: "Mini Games",
    icon: getIconFromKey("mini"),
    path: "/miniGameList",
    dataKey: "miniGameList.gameList",
    type: GameCategoryType.MINI,
    sort: 10,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "live",
    nameKey: "Live Casino",
    name: "Live Casino",
    icon: getIconFromKey("live"),
    path: "/videoConferencing",
    dataKey: "videoList.gameList",
    type: GameCategoryType.LIVE,
    sort: 13,
    enabled: false, // 默认禁用
  },
  {
    key: "bingo",
    nameKey: "Bingo",
    name: "Bingo",
    icon: getIconFromKey("bingo"),
    path: "/bingo",
    dataKey: "bingoGameList.gameList",
    type: GameCategoryType.MINI,
    sort: 11,
    enabled: true,
    showOnMobile: true,
    mobileLimit: 9,
  },
  {
    key: "favorite",
    nameKey: "Favorites",
    name: "Favorites",
    icon: getIconFromKey("favorite"),
    path: "/favoriteList",
    type: GameCategoryType.FAVORITE,
    auth: true,
    sort: 15,
    enabled: false,
  },
  {
    key: "played",
    nameKey: "Recently Played",
    name: "Recently Played",
    icon: getIconFromKey("played"),
    path: "/playedList",
    type: GameCategoryType.PLAYED,
    auth: true,
    sort: 16,
    enabled: true,
  },
];

export function sortGameCategories(
  categories: GameCategoryInfo[]
): GameCategoryInfo[] {
  return [...categories].sort((left, right) => (left.sort || 0) - (right.sort || 0));
}

/**
 * 根据不同场景过滤游戏分类
 */
export function filterGameCategories(
  categories: GameCategoryInfo[],
  options: {
    // 是否包含需要认证的分类
    includeAuth?: boolean;
    // 是否只显示移动端适配的分类
    mobileOnly?: boolean;
    // 排除的分类类型
    excludeTypes?: GameCategoryType[];
    // 只包含的分类类型
    includeTypes?: GameCategoryType[];
    // 是否登录
    isLogin?: boolean;
  } = {}
): GameCategoryInfo[] {
  const {
    includeAuth = true,
    mobileOnly = false,
    excludeTypes = [],
    includeTypes,
    isLogin = false,
  } = options;

  return categories.filter((category) => {
    // 认证检查
    if (category.auth && !isLogin && !includeAuth) {
      return false;
    }

    // 移动端检查
    if (mobileOnly && !category.showOnMobile) {
      return false;
    }

    // 排除类型检查
    if (category.type && excludeTypes.includes(category.type)) {
      return false;
    }

    // 包含类型检查
    if (includeTypes && includeTypes.length > 0) {
      return category.type && includeTypes.includes(category.type);
    }

    return true;
  });
}
